import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import Moment from 'react-moment';
import 'react-toastify/dist/ReactToastify.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import * as SpecialistBlogActions from '../../actions/SpecialistblogActions';
import autoBind from 'auto-bind';
import * as constant from '../../constants/constant';
import * as dashboardActions from "../../actions/dashboardActions";

let btnSize = { fontSize: '13' };
class SpecialistBlogList extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			blogDetailData: {},
			logoutButton: false
		}
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this._logout = this._logout.bind(this)

		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	
	}
	
	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		browserHistory.push('/');
	}
	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}
	componentWillMount() {
        
		let object = {
			blogId: this.props.match.params.blogId,
			userId: localStorage.getItem('userId')
        }
		this.props.actions.getSpecialistBlogById(this.props.match.params.blogId, localStorage.getItem('userId'))
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.success) {
			this.setState({
				blogDetailData: nextProps.blogDetailData,
			})
		}
	}



	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}

	render() {
		let blogDetailData = this.state.blogDetailData;
		let profileImage, bannerImage
		if (blogDetailData && blogDetailData.profileImage && blogDetailData.profileImage != '' && blogDetailData.profileImage != 'noUserImage.jpg') {
			profileImage = constant.PRODUCTION_IMAGE_URL + 'uploads/' + blogDetailData.userId + '/' + blogDetailData.profileImage
		} else {
			profileImage = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + constant.DEFAULT_USER_IMAGE;
		}
		if (blogDetailData && blogDetailData.bannerImage && blogDetailData.bannerImage != '') {
			bannerImage = constant.PRODUCTION_IMAGE_URL + 'uploads/' + blogDetailData.userId + '/' + blogDetailData.bannerImage
		}
		if (blogDetailData && blogDetailData.bannerImage && blogDetailData.bannerImage == 'blog_dflt_l.png') {
			bannerImage = constant.PRODUCTION_IMAGE_URL + 'uploads/common/blog_dflt_l.png'
		}
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var defaultImagePath =user.gender=='Male'? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_m.png': constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_f.png';

		if (user.image == constant.DEFAULT_USER_IMAGE) {
			if (user.gender == 'Male') {
				imagePath =  constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER  + constant.COMMON_FOLDER + 'doctor_m.png'
			}
			else{
			  imagePath =  constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER  + constant.COMMON_FOLDER + 'doctor_f.png'
			}
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var condition = (((user.userName != undefined || user.gender != undefined )&& user.availabilityCount > 0 )&& user.isVerified == '2');
		var userType = localStorage.getItem('userType');	
		return (
			<div className="">
				<header className="main-header">
				<Link to={condition ? "/specialist/my-appointment" : null} className="logo">						
				<span className="logo-mini">{userType === 'specialist' ? <img src={require('../../images/img/logo_er_ms_specialist.png')} alt="" /> : <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
				<span className="logo-lg">{userType === 'specialist' ? <img src={require('../../images/img/logo_er.png')} alt="" /> : <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button"> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>
									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link
												
												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<div className="content-wrapper">
					<section className="content container-fluid">
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB proCalendar">
									<div className="nav-tabs-custom">
										<ul className="nav nav-tabs">
											<li ><Link href="#tab_1" data-toggle="tab" className="active show">Blog Details </Link></li>
											<li className=" col-md">
												<div className="content-header"><ol className="breadcrumb">
													<li><Link to="/specialist/my-blog"> Blogs</Link></li>
													<li className="active">Blog Details</li>
												</ol></div>

											</li>
										</ul>
										<div className="row">
											<div className="col-md-12">
												<div className="tab-content tabother blogBg">
													<div className="row">
														<div className="col-md-12">
															<div className="blogInfo">
																<h2 className="h2Blog">{blogDetailData.blogTitle}</h2>
																<img src={bannerImage} className="blogImg" />
																<p dangerouslySetInnerHTML={{ __html: blogDetailData.description }}></p>
															</div>

														</div>
													</div>
												</div>
												<div className="yelbtns" ><Link className="btn btn-primary btn-signup" to="/specialist/my-blog"> Back</Link></div>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>

					</section>

					 <div className="Copyrightafterlogin">
				 <p>Medfix &copy; 2018. All rights reserved</p>

					 </div>
				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		blogDetailData: state.SpecialistBlog.blogData ? state.SpecialistBlog.blogData : {},
		success: state.SpecialistBlog.blogData ? state.SpecialistBlog.blogData.success : false,
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(SpecialistBlogActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(SpecialistBlogList);